import { FC, ReactNode, memo, useMemo } from 'react'
import theme from '@utils/theme'
import { StyledTypography } from './style'
export interface TypographyProps {
  variant?: keyof JSX.IntrinsicElements
  children?: ReactNode
  content?: string
  tc?: keyof typeof theme.colors
  size?: number
  styleText?: string
  lineHeight?: number
  weight?: number
}
const Typography: FC<TypographyProps> = memo(
  ({ children, content, weight = 400, variant = 'p', ...restProps }) => {
    const Component = useMemo(
      () => StyledTypography.withComponent(variant),
      [variant],
    )
    return (
      <Component {...restProps} weight={weight}>
        {children || content}
      </Component>
    )
  },
)

export default Typography
